const session_expired = {
    title: 'Session Expired',
    subtitle: 'Your session might have expired and you have been disconnected. Click the button below to sign in to admin console again.',
    button: 'Sign In Again',
};
export default session_expired;
